import React from "react";
import {
  List as MaterialUiList,
  ListItem,
  Card,
  CardContent,
  TablePagination,
  Typography,
  withStyles
} from "@material-ui/core";

import { ListProps } from "./types";
import useStyles from "./styles";

function List<TData>({
  items,
  renderItem,
  keyExtractor,
  paginationOptions
}: ListProps<TData>) {
  const styles = useStyles();

  return (
    <>
      <MaterialUiList className={styles.container}>
        {items.map((item, index) => (
          <CustomListItem button key={keyExtractor(item, index)}>
            <CustomCard>
              <CustomCardContent>
                <Typography component="div">{renderItem(item)}</Typography>
              </CustomCardContent>
            </CustomCard>
          </CustomListItem>
        ))}
      </MaterialUiList>

      {paginationOptions && (
        <TablePagination
          component="div"
          {...paginationOptions}
          rowsPerPageOptions={paginationOptions.rowsPerPageOptions ?? []}
        />
      )}
    </>
  );
}

export default List;

const CustomCard = withStyles({
  root: {
    padding: 10,
    width: "100%"
  }
})(Card);

const CustomCardContent = withStyles({
  root: {
    padding: 0,
    "&:last-child": {
      padding: 0
    }
  }
})(CardContent);

const CustomListItem = withStyles({
  gutters: {
    paddingLeft: 0,
    paddingRight: 0
  }
})(ListItem);
